import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RssfeedsService{
 
  private proxyUrl = 'https://api.allorigins.win/get?url=';

  constructor(private http: HttpClient) {}

  // Method to get RSS feed using Angular's HttpClient
  getRssFeed(url: string): Observable<any> {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, PATCH, OPTIONS',
      'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, Accept, Origin, Authorization'
    });

    return this.http.get(url, { responseType: 'text', headers }).pipe(
      map(response => this.parseXML(response))
    );
  }

  // Unified method to fetch and parse RSS feed from the given URL using fetch API
  async fetchAndParseRssFeed(feedName: string): Promise<any> {
    const targetUrl = `https://health.economictimes.indiatimes.com/rss/${feedName}`;

    try {
      const response = await fetch(targetUrl);
      if (!response.ok) {
        throw new Error('Network response was not ok.');
      }
      const xmlText = await response.text();

      
      return this.parseXML(xmlText);
    } catch (error) {
        
      throw error;
    }
  }

  // Utility method to parse XML to JSON
  private parseXML(xmlStr: string): any[] {
    const parser = new DOMParser();
    const xml = parser.parseFromString(xmlStr, 'text/xml');
    const items = Array.from(xml.querySelectorAll('item'));
  
    return items.map(item => {
      const mediaContent = item.getElementsByTagName('media:content')[0];
      const image = mediaContent ? mediaContent.getAttribute('url')?.replace(/\/thumb\/img-size-\d+\//, '/photo/') : null;
  
      return {
        title: item.querySelector('title')?.textContent || null,
        link: item.querySelector('link')?.textContent || null,
        description: item.querySelector('description')?.textContent || null,
        guid: item.querySelector('guid')?.textContent || null,
        pubDate: item.querySelector('pubDate')?.textContent || null,
        image
      };
    });
  }
  

 

}
